module.exports = __webpack_public_path__ + "static/media/oneforma_logo.101ca248.png";